import { RefObject, useEffect, useState } from 'react';

interface PositionStyle {
  position: 'fixed';
  bottom: string;
  right: string;
}

const useFixedPositionButton = (
  containerRef: RefObject<HTMLElement | null>
) => {
  const initialPositionStyle: PositionStyle = {
    position: 'fixed',
    bottom: '8px', // Set the initial value to 16px
    right: '0',
  };

  const [positionStyle, setPositionStyle] = useState<PositionStyle>(
    initialPositionStyle
  );

  useEffect(() => {
    const handleResize = () => {
      updateButtonPosition();
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    updateButtonPosition();
  }, [containerRef]);

  const updateButtonPosition = () => {
    if (containerRef.current) {
      const containerRect = containerRef.current.getBoundingClientRect();
      const containerRight = containerRect.right;

      const newButtonStyle: PositionStyle = {
        position: 'fixed',
        bottom: `8px`,
        right: `calc(100% - ${containerRight}px)`,
      };

      setPositionStyle(newButtonStyle);
    }
  };

  return { positionStyle };
};

export default useFixedPositionButton;
